// extracted by mini-css-extract-plugin
export default {"flex-column":"otp_flex-column__Y0Tah","otp":"otp_otp__33bh+","flex-row":"otp_flex-row__aCRG+","page-size":"otp_page-size__dHjW6"};